import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getAllBillings, getBrandList, getClientList, getMarketList } from '../../../../slices/auth/settings/thunk';
import { getBillingSuccess, getMarketSuccess, setBrandId, setClientId, setMarketId } from '../../../../slices/auth/settings/reducer';
import 'datatables.net-buttons-bs5';
import 'datatables.net-responsive-bs5';
import { setEditMarketModalData, toggleActivateMarketModal, toggleDeleteMarketModal, toggleEditMarketModal } from '../../../../slices/modals/reducer';
import { setInnerPreloader } from '../../../../slices/layouts/reducer';
const $ = require("jquery");
$.DataTable = require("datatables.net-bs5");
import { replace } from "redux-first-history";
import country from '../../../../common/country';
import { toast } from 'react-toastify';
import { setMarketPath } from '../../../../slices/auth/menu/thunk';

/**
 * @component
 * Represents the MarketTable component, which displays and manages market information, including adding, deleting, and editing markets.
 */
function MarketTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const selectClientAndBrandId = createSelector((state) => state, (state) => ({
    clients: state.Settings.clients,
    clientId: state.Settings.selectedClientId,
    brands: state.Settings.brands,
    brandId: state.Settings.selectedBrandId,
    permission: state.Permission.permission,
  }));
  const { clients, clientId, brands, brandId, permission } = useSelector(selectClientAndBrandId);

  // Brand Data
  const selectMarketData = createSelector(state => state.Settings, state => state.markets);
  const marketData = useSelector(selectMarketData);
  const [market, setMarket] = useState([]);

  useEffect(() => {
    setMarket(marketData);
  }, [marketData]);

  // Table
  /* eslint-disable no-unused-vars */
  const tableRef = useRef();
  useEffect(() => {
    try {
      const table = $(tableRef.current).DataTable({
        data: market,
        columns: [
          // {
          //   data: null,
          //   title: `<input type="checkbox" class="form-check-input" />`,
          //   orderable: false,
          //   render: () => {
          //     return `<input type="checkbox" class="form-check-input" />`
          //   }
          // },
          {
            data: "name",
            title: "Market Name",
            render: (data, type, row) => {
              let foundCountry = country.find(item => item.name === data);
              return `
              <img src="${foundCountry.flagImg}" class="me-1" height="15" />
              <a class="market" role="button" data-id="${row.id}">${data}</a>
              `
            }
          },
          {
            data: 'creativeCount',
            title: "Number Of Creative Sets",
            render: (data, type, row) => {
              if (data) {
                return data;
              } else {
                return '0'
              }
            }
          },
          {
            data: null,
            title: "Status",
            render: (data, type, row) => {
              switch (row.status) {
                case true:
                  return `<span class="badge bg-success-subtle text-primary fs-11 text-uppercase">
                                          <i class="ri-checkbox-circle-line align-bottom"></i> Active
                                      </span>`;

                case false:
                  return `<span class="badge bg-danger-subtle text-primary fs-11 text-uppercase">
                                          <i class="ri-close-circle-line align-bottom"></i> Inactive
                                      </span>`;

              }
            }
          },
          {
            data: null,
            title: "Action",
            render: (data, type, row) => {
              let editBtnStr = ``;
              let toggleMarketBtnStr = ``;

              if (permission.markets[row._id]) {
                if (permission.markets[row._id].permissionsWK.includes('companyDetailsEdit')) {
                  editBtnStr = `
                          <div class='edit d-inline-block align-items-center'>
                              <button class='btn btn-sm edit-item-btn text-muted fs-14'>
                                  <i class='ri-pencil-fill align-bottom'></i>
                              </button>
                          </div>`;
                }
                if (permission.markets[row._id].permissionsWK.includes('companyDetailsDelete')) {
                  if (row.status === true) {
                    toggleMarketBtnStr = `<div class='remove d-inline-block align-items-center'>
                                  <button class='btn btn-sm remove-item-btn text-muted fs-14'>
                                      <i class="ri-delete-bin-fill align-bottom"></i>
                                  </button>
                              </div>`
                  } else {
                    toggleMarketBtnStr = `<div class='remove d-inline-block align-items-center'>
                                  <button class='btn btn-sm remove-item-btn text-muted fs-14'>
                                      <i class="ri-lock-unlock-fill align-bottom"></i>
                                  </button>
                              </div>`
                  }
                }
              }
              return `<div>${editBtnStr}${toggleMarketBtnStr}</div>`;
            }
          }
        ],
        responsive: true,
        columnDefs: [
          { responsivePriority: 1, targets: [1, -2] },
          { responsivePriority: 2, targets: "_all" }
        ],
        language: {
          search: "<i class='ri-search-line search-icon'></i>",
          searchPlaceholder: "Search for markets..."
        },
        info: false,
        destroy: true,
      });
      /* eslint-enable no-unused-vars */

      table.on("click", ".edit", function () {
        let tr = $(this).closest("tr");
        if ($(tr).hasClass("child")) {
          tr = $(tr).prev();
        }
        let data = table.row(tr).data();
        if (data) {
          dispatch(setMarketId(data._id));
          dispatch(setEditMarketModalData(data));
          dispatch(getBillingSuccess(null));
          dispatch(getAllBillings());
          dispatch(toggleEditMarketModal());
        }
      });

      table.on("click", ".remove", function () {
        let tr = $(this).closest("tr");
        if ($(tr).hasClass("child")) {
          tr = $(tr).prev();
        }
        let data = table.row(tr).data();
        if (data) {
          dispatch(setMarketId(data._id));
          if (data.status === true) {
            dispatch(toggleDeleteMarketModal());
          } else {
            dispatch(toggleActivateMarketModal());
          }
        }
      });

      return function () {
        table.destroy();
      }
    } catch (error) {
      // console.log(error);
      toast.error('Something went wrong', { autoClose: 3000 });
    }

  }, [market]);
  return (
    <div>
      <table className='align-middle table-nowrap mb-0 table' style={{ width: "100%" }} ref={tableRef}>
        <thead className='table-light'></thead>
        <tbody></tbody>
      </table>
    </div>
  )
}

export default MarketTable
